import request from "../../Requests/requests"
import { TaskPost } from "../../Types/Types";

interface addTaskProps {
    payload: TaskPost,
    getListVariantTask: Function 
}

export function addTask({payload, getListVariantTask}: addTaskProps) {
    return async () => {
        try {
            const response = await request.post('/Task', {
                userId: localStorage.getItem('userID'),
                title: payload.title,
                description: payload.description,
                date: payload.date,
                time: payload.time ? payload.time : null,
                priority: payload.priority,
                hours: payload.hours,
                minutes: payload.minutes,
                tagsId: payload.tagsId ? payload.tagsId : null,
                repitPeriod: payload.repitPeriod,
                isRepit: payload.isRepit,
                templateTime: payload.templateTime ?? '',
                intervalType: payload.intervalType ?? 1,
                interval: payload.interval ?? 0,
                selectedWeekDays: payload.selectedWeekDays ?? null,
                selectedMonthDays: payload.selectedMonthDays ?? null,
                endType: payload.endType ?? 1,
                dateEnd: payload.dateEnd ?? '',
                repitCount: payload.repitCount ?? 0,
                isCreatedAfterCompited: payload.isCreatedAfterCompited ?? false,
                notificationType: payload.notificationType
            })
            const data = response.data
            return data
        } catch (error) {
            return error
        }
    }
}